import React from "react"

import { Link, withRouter } from "react-router-dom";
import moment from "moment";

import BaseTable from "./BaseTable"
import Authorisation from "../modal/Authorisation";
import Edit from "./cells/Edit";
import Delete from "./cells/Delete";
import Party from "../modal/Party";
import General from "../../../utils/General";
import Backend from "../../../utils/Backend";
import Notify from "../../../utils/Notify";
import Confirmation from "../modal/Confirmation";

class ContactTable extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      live: props.live
    }

    this.table = React.createRef()
  }

  _handleDelete(party){
    Backend.deleteParty(party).then(() => {
      Notify.success("Contacted Deleted.")
      this.setState({showConfirmationModal: false, selectedParty: null})
      this.table.current.refresh()
    }).catch(e => Notify.error(e.message))
  }

  _getColumns(){
    let columns = [
      {
        Header: 'Name',
        id: 'name',
        accessor: contact => General.toTitleCase(contact.name),
      },
      {
        Header: 'Email',
        id: 'email',
        accessor: contact => General.toTitleCase(contact.email),
      },
      {
        Header: 'Date Added',
        id: 'created_at',
        accessor: contact => moment(contact.created_at).format('DD MMM YYYY'),
        type: "date",
        format: "%d %b %Y"
      },
      {
        Header: '',
        id: '',
        sortable: false,
        exportable: false,
        Cell: rowInfo => {
          let party = rowInfo.original
          return (
            <div className={"text-end my-auto"}>
              <Edit
                onEditClicked={() => {
                  this.setState({
                    showPartyModal: true,
                    selectedParty: party
                  })
                }}
              />
              <Delete
                onDeleteClicked={() => {
                  this.setState({showConfirmationModal: true, selectedParty: party})
                }}
              />
            </div>
          )
        }
      }
    ]

    return columns
  }

  render() {
    let {
      showPartyModal,
      selectedParty,
      showConfirmationModal
    } = this.state

    const columns = this._getColumns()

    return (
      <>
        <BaseTable
          ref={this.table}
          endpoint={`${window.Api.Parties}?type=contact`}
          noDataMessage={"No contacts found"}
          title={this.props.title}
          columns={columns}
          defaultSorted={[
            {
              id: "created_at",
              desc: true
            }
          ]}
          renderToolbar={() => (
            <>
              <div className="card-toolbar" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-trigger="hover"
                   data-kt-initialized="1" data-bs-original-title="" title="">
                <a
                  href="#"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#kt_modal_invite_friends"
                  onClick={() => this.setState({showPartyModal: true, selectedParty: {type: "contact"}})}
                >
                  <span className="svg-icon svg-icon-3">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1"
                            transform="rotate(-90 11.364 20.364)" fill="currentColor"/>
                      <rect x="4.36396" y="11.364" width="16" height="2" rx="1" fill="currentColor"/>
                    </svg>
                  </span>
                  Add Contact
                </a>
              </div>
            </>
          )}
        />
        {
          showPartyModal &&
          <Party
            name={"Contact"}
            show={showPartyModal}
            party={selectedParty}
            onHide={() => this.setState({showPartyModal: false, selectedParty: null})}
            onSubmit={() => {
              this.table.current.refresh()
              this.setState({showPartyModal: false, selectedParty: null})
            }}
          />
        }
        {
            showConfirmationModal &&
            <Confirmation
                show={showConfirmationModal}
                onConfirm={() => this._handleDelete(selectedParty)}
                onHide={() => this.setState({showConfirmationModal: false, selectedParty: null})}
            />
        }
      </>
    )

  }

}

export default withRouter(ContactTable);
